import { Component, Input, OnInit } from '@angular/core';
import { RibbonTileSection } from 'src/app/model/section/ribbon-tile-section';

@Component({
  selector: 'app-payments-ribbon-tile-section',
  templateUrl: './payments-ribbon-tile-section.component.html',
  styleUrls: ['./payments-ribbon-tile-section.component.scss']
})
export class PaymentsRibbonTileSectionComponent implements OnInit {
  @Input() ribbonTileSections: RibbonTileSection[] = [];
  @Input() isAPIFlow: boolean = false;

  constructor() {}

  ngOnInit(): void {}
}
